import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { constructTealiumMiddleware, coreTags } from '../../core/js/middleware/analytics';
import { productTags } from './middleware/analytics';
import productApp from './init/productApp';
import productInitialState from './init/productInitialState';
import { initialState as coreInitialState } from '../../core/js/store';
import ravenMiddleware from '../../core/js/middleware/raven';
import { storeLogger } from '../../core/js/middleware/logger';

export const initialState = Object.assign({}, coreInitialState, productInitialState, {
    core: Object.assign({}, coreInitialState.core, {
        pageType: 'pdp'
    })
});

export function configureStore() {
    const tealiumMiddleware = constructTealiumMiddleware([coreTags(), productTags()]);
    const sagaMiddleware = createSagaMiddleware();

    const createStoreWithMiddleware = createStore(
        productApp,
        initialState,
        applyMiddleware(storeLogger('Product'), ravenMiddleware, tealiumMiddleware, sagaMiddleware)
    );
    return Object.assign({}, createStoreWithMiddleware, { runSaga: sagaMiddleware.run });
}
